import * as React from 'react';
import { useTranslation } from 'react-i18next';
import SubmitButton from 'shared/components/SubmitButton';
import { useArchiveMutation } from './hooks';

interface Props {
  orderId: number;
}

export const ArchiveStockButton: React.FC<Props> = ({ orderId }) => {
  const { t } = useTranslation();
  const { archive, loading, error } = useArchiveMutation(orderId);

  return (
    <SubmitButton onClick={archive} primary error={error} submitting={loading}>
      {t('Archive')}
    </SubmitButton>
  );
};
